<script lang="ts">
    import { CURRENT_PURCHASE_PAYMENT, CURRENT_PURCHASE_PRODUCT, LATEST_PURCHASE } from "../../Stores/Purchase";   
    import checkIcon from "../../Icons/check-circle.svg";
    import Purchase from "../../Models/Purchase";
    import { toasts } from "svelte-toasts";

    let currentPurchasePayment;
    let currentPurchaseProduct;

    CURRENT_PURCHASE_PAYMENT.subscribe(data => currentPurchasePayment = data);
    CURRENT_PURCHASE_PRODUCT.subscribe(data => currentPurchaseProduct = data);

    async function sendPurchase() {
        if (currentPurchasePayment) {
            const res = await Purchase.add(currentPurchaseProduct.value, currentPurchasePayment);
            if (res._id) LATEST_PURCHASE.set(res._id);
        } else {
            toasts.error(`Zakup nie został dodany`, `Nie zdefiniowano informacji o płatności.`)
        }
    }
</script>

{#if currentPurchaseProduct.value}
    <section class="sendPurchase">
        <button on:click={sendPurchase}>
            <span class="icon">{@html checkIcon}</span>
            Potwierdź!
        </button>
    </section>
{/if}

<style type="text/scss">
    .sendPurchase {
        button {
            background: white;
            border: 1px solid gray;
            border-radius: 5px;
            display: flex;
            margin-top: .5rem;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .icon {
                margin-right: .25rem;
            }
        }
    }
</style>